module.exports = __webpack_public_path__ + "img/blz.64d617ea.svg";